// @flow

let bodyScrollPosition = 0;
const html = document.querySelector("html");
const body = document.querySelector("body");
let scrollDisableCount = 0;

export const enableBodyScroll = (): Function => {
    // dont allow count to go below zero, required because all modals are closed on page load
    if (scrollDisableCount <= 0) return;

    scrollDisableCount = scrollDisableCount - 1;
    if (scrollDisableCount === 0) {
        if (html && body && html.classList.contains("prevent-scrolling")) {
            html.classList.remove("prevent-scrolling");
            body.style.top = "auto";
            window.scroll(null, bodyScrollPosition);
        }
    }
};

export const disableBodyScroll = () => {
    if (scrollDisableCount === 0) {
        if (html && body && !html.classList.contains("prevent-scrolling")) {
            bodyScrollPosition = window.scrollY;
            html.classList.add("prevent-scrolling");
            body.style.top = `${bodyScrollPosition * -1}px`;
        }
    }
    scrollDisableCount = scrollDisableCount + 1;
};
